export class BacsConfiguration {
  elements: BacsConfigurationElements[];
  conditionDateFields: string[];
}

export class BacsConfigurationElements {
  element: string;
  fields: BacsConfigurationElementsFields[];
}

export class BacsConfigurationElementsFields {
  name: string;
  type: string;
  description: string;
  comparators: string[];
}
